
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const IntegerFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: number,
  onChange: (value: string, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const required = checkLayoutFieldRequirement(layoutField);
  const [error, setError] = useState(required && (value === undefined || value === null));

  //number of digits left and right if the comma
  const stepSize = 1

  const handleChange = (event: any) => {
    const value = event.target.value;

    if(value === null || value === undefined){
      setError(true)
    } else {
      setError(false)
    }


    onChange(value, layoutField);
  }


  return (
      <TextField
         fullWidth
         error={error}
         disabled={layoutField.AccessSetting_sys === 'read'}
         size="small"
         label={`${layoutField.ReferencedField_sys.Label_sys}`}
         variant="filled"
         type="number"
         value={value}
         onChange={(event) => handleChange(event)}
         helperText={layoutField.ReferencedField_sys.HelpText_sys}
         InputProps={{
           inputProps: {type: 'number',
                        step: stepSize,
                        min: 0,
                        inputMode: "numeric",
                        pattern: "[0-9]",
                      },
          }}
      />

    );

};
